export default __webpack_public_path__ + "static/media/portfoilo-disply.5ad02303.png";